module.exports = __webpack_public_path__ + "static/img/mechanism-6.cf9cdd21.png";